"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isMobileView = void 0;
// (C) 2019-2021 GoodData Corporation
var constants_1 = require("../../DashboardLayout/constants");
// https://github.com/gooddata/gdc-goodstrap/blob/master/src/core/MediaQueries.js#L61
exports.isMobileView = function () { return window.innerWidth <= constants_1.SCREEN_BREAKPOINT_SM; };
//# sourceMappingURL=responsive.js.map